var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaterial = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2240",
  d: "M54.94 29.902a19.7 19.7 0 0 1-4.44-3.416 19.8 19.8 0 0 1-3.42-4.44 11 11 0 0 1-.474-1.009L17.9 50.468a1.48 1.48 0 0 0-.394 1.377l1.314 5.813a1.48 1.48 0 0 0 1.118 1.118l5.813 1.31a1.48 1.48 0 0 0 1.372-.4L55.78 30.305c-.287-.131-.555-.25-.84-.402m-24.75 19.39a1.416 1.416 0 0 1-2.436-.947 1.416 1.416 0 0 1 1.383-1.444 1.416 1.416 0 0 1 1.444 1.382c.009.375-.132.738-.391 1.01m3.348-3.5a1.416 1.416 0 0 1-2.435-.946 1.416 1.416 0 0 1 1.382-1.445c.375-.008.738.133 1.01.392a1.416 1.416 0 0 1 .04 2zm3.35-3.499a1.416 1.416 0 0 1-2.435-.947 1.416 1.416 0 0 1 1.382-1.444 1.416 1.416 0 0 1 1.053 2.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M22.866 21.287a1.19 1.19 0 0 0-1.71-.009l-.017.018-6.466 6.466c-.548.548-.99 1.517-.373 3.258.136.276.263.618.452.965a18.2 18.2 0 0 0 3.117 4.024 18.2 18.2 0 0 0 4.029 3.122q.462.265.964.447.463.176.95.266a2.59 2.59 0 0 0 2.284-.547l6.554-6.52a1.22 1.22 0 0 0-.035-1.735zm1.35 15.37a11.8 11.8 0 0 1-4.055-2.9 11.8 11.8 0 0 1-2.906-4.046l4.748-4.748 2.305 2.305-2.612 2.618a1.606 1.606 0 1 0 2.27 2.27l2.613-2.612 2.376 2.376z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2240",
  d: "M43.887 17.865a19.7 19.7 0 0 1-4.442-3.416 19.8 19.8 0 0 1-3.42-4.441A11 11 0 0 1 35.553 9L24.295 20.484c-.04.04 8.963 9.48 9.322 9.121l11.11-11.337c-.287-.132-.554-.25-.84-.403"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h70v70H0z"
})))));
export { SvgMaterial as ReactComponent };
export default "/_next/static/images/material.svg";